/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CandidateOfferItem from './CandidateOfferItem';
import Pagination from './Pagination';

/**
 * The CandidateOfferItemPaginated model module.
 * @module model/CandidateOfferItemPaginated
 * @version v1
 */
class CandidateOfferItemPaginated {
    /**
     * Constructs a new <code>CandidateOfferItemPaginated</code>.
     * Item ligero de oferta para listados vista candidato paginado [P_A_02] [P_A_11]
     * @alias module:model/CandidateOfferItemPaginated
     */
    constructor() { 
        
        CandidateOfferItemPaginated.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateOfferItemPaginated</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateOfferItemPaginated} obj Optional instance to populate.
     * @return {module:model/CandidateOfferItemPaginated} The populated <code>CandidateOfferItemPaginated</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateOfferItemPaginated();

            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], [CandidateOfferItem]);
            }
            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = Pagination.constructFromObject(data['pagination']);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/CandidateOfferItem>} data
 */
CandidateOfferItemPaginated.prototype['data'] = undefined;

/**
 * @member {module:model/Pagination} pagination
 */
CandidateOfferItemPaginated.prototype['pagination'] = undefined;






export default CandidateOfferItemPaginated;

